import { FRONTEND_METRICS_API_URL } from '@/common/config'
import { logger } from '@/services/logger/loggers'
import { getAuth0Header } from '@/services/tokenManager'
import { TranslationInterceptor } from '@sennder/shell-utilities'

if (!FRONTEND_METRICS_API_URL) {
  throw new Error('FRONTEND_METRICS_API_URL not defined')
}

export const translationInterceptor = new TranslationInterceptor(
  FRONTEND_METRICS_API_URL,
  getAuth0Header,
  logger
)
